export const PRIORITY_ID = 1;
export const CM_OPTION = -1;
export const REF_CODE = '';
export const REMARKS = '';
export const IS_COMPLY = null;
